import { render, staticRenderFns } from "./DuplicateCheck.vue?vue&type=template&id=1c1dc45a&scoped=true"
import script from "./DuplicateCheck.vue?vue&type=script&lang=js"
export * from "./DuplicateCheck.vue?vue&type=script&lang=js"
import style0 from "./DuplicateCheck.vue?vue&type=style&index=0&id=1c1dc45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1dc45a",
  null
  
)

export default component.exports